/**
 * Date-extensions locale Tetun Dili (East Timor) [tet]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('tet', {
    monthNames: ['Janeiru','Fevereiru','Marsu','Abril','Maiu','Juniu','Juliu','Augustu','Setembru','Outubru','Novembru','Dezembru'],
    monthShortNames: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Aug','Set','Out','Nov','Dez'],
    dayNames: ['Domingu','Segunda','Tersa','Kuarta','Kinta','Sexta','Sabadu'],
    dayShortNames: ['Dom','Seg','Ters','Kua','Kint','Sext','Sab']
});
